import React from 'react';
import { ScrollFooterActions, ScrollFooterActionsStacked } from './modalScrollProgressStyles';

function WizardModalScrollFooter({ children, footerLayout = 'row' }) {
  const ActionsShell = footerLayout === 'stacked' ? ScrollFooterActionsStacked : ScrollFooterActions;

  return <ActionsShell>{children}</ActionsShell>;
}

export default WizardModalScrollFooter;
